export function updateReadyStore(store, key, ready) {
    store.update(v => {
        const state = new Map(v)
        state.set(key, ready);
        return state;
    })
}

export function removeReadyStoreKey(store, key) {
    store.update(v => {
        const state = new Map(v)
        state.delete(key);
        return state;
    })
}